import EndScreen from "./scenes/EndScreen";
import Game from "./scenes/Game";
import GameBackground from "./scenes/GameBackground";
import Instructions from "./scenes/Instructions";
import Intro from "./scenes/Intro";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [GameBackground, Intro, Instructions, Game, EndScreen],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: GameBackground.KEY,
    firstScene: Intro.KEY,
    // firstScene: Instructions.KEY,
    // firstScene: Game.KEY,
    // firstScene: EndScreen.KEY,

    isMobile: false,
    // set this to true to force mobile in dev (forces mobile layout even when on desktop, is ignored on staging/production)
    // forceMobile: true,

    UNREADY_COLOR: 0x000000,
    READY_COLOR: 0xffffff,
    KEY_DOWN_COLOR: 0x999999,
    KEY_UP_COLOR: 0xffffff,

    gameTime: 0,
    bestTime: 0
}
